const humanizeGasType = (type) =>
  !type
    ? 'Gas'
    : type
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

export default humanizeGasType;
